<template>
  <div class="p-6 bg-gray-50 min-h-screen">
    <div class="flex justify-between items-center mb-6">
      <p class=" font-bold text-gray-800 inline-block transition-all duration-500">
        <span class="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500">
          داشبورد گزارش تاریخچه موجودی برای محصول
          <span class="text-black">{{ product.name || 'نامشخص' }}</span>
        </span>
      </p>
      <div class="relative">
        <input
            v-model="productId"
            type="number"
            class="pl-10 pr-4 py-2  ring-2 ring-blue-800  text-blue-900  rounded-lg focus:ring-3"
            placeholder="شناسه را وارد کنید"
        >
        <button
            @click="refreshData"
            class="p-2 bg-blue-500 rounded-lg shadow-sm mr-2 "
            title="دریافت گزارش"
        >
          <v-icon class="white--text">fa-search</v-icon>
        </button>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" v-if="storeInventories.length > 0">
      <div class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-500">
        <div class="flex items-center">
          <div class="p-3 rounded-lg bg-blue-100 text-blue-600 mr-4">
            <i class="fas fa-store text-xl"></i>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-500 mr-4">تعداد انبار ‌ها</p>
            <h2 class="text-2xl font-bold text-gray-800 mr-4">{{ filteredStoreInventories.length }}</h2>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-green-500">
        <div class="flex items-center">
          <div class="p-3 rounded-lg bg-green-100 text-green-600 mr-4">
            <i class="fas fa-boxes text-xl"></i>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-500 mr-4">مجموع موجودی</p>
            <h2 class="text-2xl font-bold text-gray-800 mr-4">{{ formatNumber(totalInventory) }}</h2>
          </div>
        </div>
      </div>
      <div class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-yellow-500">
        <div class="flex items-center">
          <div class="p-3 rounded-lg bg-yellow-100 text-yellow-600 mr-4">
            <i class="fas fa-lock text-xl"></i>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-500 mr-4">مجموع رزرو شده</p>
            <h2 class="text-2xl font-bold text-gray-800 mr-4">{{ formatNumber(totalReserved) }}</h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="bg-white rounded-xl p-4 mb-6 shadow-sm border border-gray-100" v-if="storeInventories.length > 0">
      <div class="flex flex-wrap items-center gap-3">
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <i class="fas fa-search text-gray-400"></i>
          </div>
          <input
              v-model="searchQuery"
              type="text"
              class="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-64"
              placeholder="جستجو انبار..."
          >
        </div>

        <!-- Action Buttons -->
        <div class="flex gap-2">
          <button
              @click="resetFilters"
              class="px-4 py-2 bg-gradient-to-r from-gray-500 to-gray-700 text-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105 flex items-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            پاک کردن فیلتر
          </button>

          <button
              @click="exportToCSV"
              class="px-4 mr-2 py-2 bg-gradient-to-r from-green-500 to-green-700 text-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105 flex items-center"
              :disabled="storeInventories.length === 0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 ml-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            خروجی اکسل
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" v-if="storeInventories.length > 0">
      <div class="overflow-x-auto">
        <table class="min-w-full">
          <thead class="bg-gray-50">
          <tr>
            <th class="p-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" @click="sortBy('store')">
              نام انبار
              <i class="fas ml-1" :class="sortKey === 'store' ? (sortOrders['store'] > 0 ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'"></i>
            </th>
            <th class="p-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" @click="sortBy('inventory')">
              موجودی فعلی
              <i class="fas ml-1" :class="sortKey === 'inventory' ? (sortOrders['inventory'] > 0 ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'"></i>
            </th>
            <th class="p-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" @click="sortBy('reserved_inventory')">
              رزرو شده
              <i class="fas ml-1" :class="sortKey === 'reserved_inventory' ? (sortOrders['reserved_inventory'] > 0 ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'"></i>
            </th>
            <th class="p-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" @click="sortBy('minimum_inventory')">
              حداقل موجودی
              <i class="fas ml-1" :class="sortKey === 'minimum_inventory' ? (sortOrders['minimum_inventory'] > 0 ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort'"></i>
            </th>
            <th class="p-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">عملیات</th>
          </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
          <tr v-if="filteredStoreInventories.length === 0">
            <td colspan="5" class="p-4 text-center text-gray-500">
              یافت نشد
            </td>
          </tr>
          <template v-for="(item, index) in filteredStoreInventories">
            <tr
                :key="`store-${index}`"
                class="hover:bg-gray-50 transition-colors duration-200"
                :class="{ 'bg-red-50': item.inventory < item.minimum_inventory }"
            >
              <td class="p-4 font-medium text-gray-900">
                <div class="flex items-center">
                  <div class="w-3 h-3 rounded-full mr-2" :class="getStoreColor(item.store)"></div>
                  {{ item.store }}
                </div>
              </td>
              <td class="p-4 text-gray-800">{{ formatNumber(item.inventory) }}</td>
              <td class="p-4 text-gray-800">{{ formatNumber(item.reserved_inventory) }}</td>
              <td class="p-4 text-gray-800">{{ formatNumber(item.minimum_inventory) }}</td>
              <td class="p-4">
                <button
                    @click="toggleExpand(item.id)"
                    class="text-blue-500 hover:text-blue-700"
                >
                  <i class="fas" :class="expanded[item.id] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </button>
              </td>
            </tr>
            <tr v-if="expanded[item.id]" :key="`history-${index}`">
              <td colspan="5" class="p-4 bg-gray-100">
                <div class="overflow-x-auto">
                  <table class="min-w-full bg-white rounded-lg">
                    <thead class="bg-gray-200">
                    <tr>
                      <th class="p-2 text-right text-xs font-medium text-gray-500">اقدام</th>
                      <th class="p-2 text-right text-xs font-medium text-gray-500">مقدار تغییر</th>
                      <th class="p-2 text-right text-xs font-medium text-gray-500">از</th>
                      <th class="p-2 text-right text-xs font-medium text-gray-500">به</th>
                      <th class="p-2 text-right text-xs font-medium text-gray-500">زمان</th>
                      <th class="p-2 text-right text-xs font-medium text-gray-500">توسط</th>
                      <th class="p-2 text-right text-xs font-medium text-gray-500">یادداشت</th>
                    </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-100">
                    <tr v-for="(hist, hIndex) in sortedHistory(item.history)" :key="hIndex" class="hover:bg-gray-50" :class="{'bg-green-50': hist.action === 'i', 'bg-red-50': hist.action === 'd', 'bg-blue-50': hist.action === 's'}">
                      <td v-if="hist.action != 's'" class="p-2" :class="hist.action === 'i' ? 'text-green-600' : 'text-red-600'">{{ hist.action_display }}</td>
                      <td v-else class="p-2 text-blue-600" >{{ hist.action_display }}</td>
                      <td class="p-2">{{ formatNumber(hist.quantity) }}</td>
                      <td class="p-2">{{ formatNumber(hist.previous_quantity) }}</td>
                      <td class="p-2">{{ formatNumber(hist.new_quantity) }}</td>
                      <td class="p-2">{{ formatDate(hist.timestamp) }}</td>
                      <td class="p-2">{{ hist.changed_by }}</td>
                      <td class="p-2">{{ hist.note }}</td>
                    </tr>
                    <tr v-if="item.history.length === 0">
                      <td colspan="7" class="p-2 text-center text-gray-500">بدون تاریخچه</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Message if no data -->
    <div v-if="storeInventories.length === 0" class="text-center text-gray-500 mt-10">
      لطفاً شناسه محصول را وارد کنید و سپس داده‌ها را بارگیری کنید.
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryHistoryByStoreReport',
  data() {
    return {
      product: {
        id: 0,
        name: ''
      },
      storeInventories: [],
      searchQuery: '',
      sortKey: 'store',
      sortOrders: {
        store: 1,
        inventory: 1,
        reserved_inventory: 1,
        minimum_inventory: 1
      },
      expanded: {},
      productId: ''
    }
  },
  computed: {
    filteredStoreInventories() {
      let data = [...this.storeInventories];

      // Filter by search query
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        data = data.filter(item => item.store.toLowerCase().includes(query));
      }

      // Sort data
      if (this.sortKey) {
        data.sort((a, b) => {
          let modifier = 1;
          if (this.sortOrders[this.sortKey] === -1) modifier = -1;

          if (a[this.sortKey] < b[this.sortKey]) return -1 * modifier;
          if (a[this.sortKey] > b[this.sortKey]) return 1 * modifier;
          return 0;
        });
      }

      return data;
    },
    totalInventory() {
      return this.filteredStoreInventories.reduce((sum, item) => sum + item.inventory, 0);
    },
    totalReserved() {
      return this.filteredStoreInventories.reduce((sum, item) => sum + item.reserved_inventory, 0);
    },
    totalMinimum() {
      return this.filteredStoreInventories.reduce((sum, item) => sum + item.minimum_inventory, 0);
    }
  },
  methods: {
    fetchData() {
      if (!this.productId) {
        alert('لطفاً شناسه محصول را وارد کنید.');
        return;
      }
      // Assuming this.request is a method to make API calls, adjust as per your setup
      this.request({
        url: this.endpoint(`product/inventoryHistoryByStoreReport/${this.productId}`),
        method: 'get',
        success: (data) => {
          this.product = data.product;
          this.storeInventories = data.store_inventories.map(store => ({
            ...store,
            history: store.history.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)) // Sort history descending
          }));
        },
        error: () => {
          cosnole.log(error)
          alert('خطا در بارگیری داده‌ها.');
        }
      });
    },
    formatNumber(num) {
      return new Intl.NumberFormat('en-US').format(num);
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString('fa-IR', { dateStyle: 'medium', timeStyle: 'short' });
    },
    sortBy(key) {
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.sortKey = key;
    },
    getStoreColor(store) {
      const colors = [
        'bg-red-500',
        'bg-blue-500',
        'bg-green-500',
        'bg-yellow-500',
        'bg-purple-500',
        'bg-pink-500',
        'bg-indigo-500',
        'bg-teal-500',
        'bg-orange-500',
        'bg-gray-500',
      ];
      const seed = store.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
      const randomIndex = seed % colors.length;
      return colors[randomIndex];
    },
    sortedHistory(history) {
      return [...history];
    },
    toggleExpand(id) {
      this.$set(this.expanded, id, !this.expanded[id]);
    },
    refreshData() {
      this.fetchData();
    },
    resetFilters() {
      this.searchQuery = '';
      this.sortKey = 'store';
      this.sortOrders = {
        store: 1,
        inventory: 1,
        reserved_inventory: 1,
        minimum_inventory: 1
      };
      this.expanded = {};
      // Optionally reset productId or refetch
    },
    exportToCSV() {
      if (this.storeInventories.length === 0) return;

      const headers = ['فروشگاه', 'موجودی فعلی', 'رزرو شده', 'حداقل موجودی'];
      const csvData = this.filteredStoreInventories.map(item => [
        item.store,
        item.inventory,
        item.reserved_inventory,
        item.minimum_inventory
      ]);

      let csvContent = headers.join(',') + '\n' + csvData.map(row => row.join(',')).join('\n') + '\n\n';

      this.filteredStoreInventories.forEach(item => {
        if (item.history.length > 0) {
          csvContent += `تاریخچه برای ${item.store}\n`;
          const histHeaders = ['اقدام', 'مقدار', 'قبلی', 'جدید', 'زمان', 'توسط', 'یادداشت'];
          const histData = item.history.map(hist => [
            hist.action_display,
            hist.quantity,
            hist.previous_quantity,
            hist.new_quantity,
            hist.timestamp,
            hist.changed_by,
            hist.note
          ]);
          csvContent += histHeaders.join(',') + '\n' + histData.map(row => row.join(',')).join('\n') + '\n\n';
        }
      });

      const encodedUri = 'data:text/csv;charset=utf-8,\uFEFF' + encodeURIComponent(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', `inventory_history_${this.product.name ? this.product.name.replace(/\s+/g, '_') : 'unknown'}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>